var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamesBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    viewBox: "0, 0, 500, 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.56,195.5 L448.56,451.916 L45.56,451.916 L45.56,195.5 L448.56,195.5 z M247.06,215.188 L212.122,285.453 L134,296.721 L190.53,351.415 L177.185,428.645 L247.06,392.182 L316.935,428.645 L303.59,351.415 L360.12,296.721 L281.997,285.453 L247.06,215.188 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.56,195.5 L448.56,451.916 L45.56,451.916 L45.56,195.5 L448.56,195.5 z M247.06,215.188 L212.122,285.453 L134,296.721 L190.53,351.415 L177.185,428.645 L247.06,392.182 L316.935,428.645 L303.59,351.415 L360.12,296.721 L281.997,285.453 L247.06,215.188 z",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 22,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.56,58.916 L433.56,58.916 L433.56,140.5 L63.56,140.5 L63.56,58.916 z",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 57,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.5,67.5 L155.5,67.5 L155.5,129.5 L77.5,129.5 L77.5,67.5 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5,67.5 L155.5,67.5 L155.5,129.5 L77.5,129.5 L77.5,67.5 z",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M340.5,67.5 L426.5,67.5 L426.5,129.5 L340.5,129.5 L340.5,67.5 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5,67.5 L426.5,67.5 L426.5,129.5 L340.5,129.5 L340.5,67.5 z",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 57
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamesBox);
export default __webpack_public_path__ + "static/media/GamesBox.b830e0d369c21311e015484f2e92d37e.svg";
export { ForwardRef as ReactComponent };